import { RootState } from 'editor/src/store/index';

const getPreviewModePluginName = (state: RootState, elementId: number) =>
  state.editor.pluginPreviewMode?.elementUuid === elementId ? state.editor.pluginPreviewMode.pluginName : undefined;

export default getPreviewModePluginName;
